import { StateSetter } from '../../../../../_grid/grid3';
import { createCtx } from '../../../../../components/Contexts/createCtx';

export const [useRowExpandContext, RowExpandContextProvider] = createCtx<{ expanded: boolean; setExpanded: StateSetter<boolean> }>();
